import { NgModule } from '@angular/core';
import { AmdInputDirective } from './input.directive';
var AmdInputModule = /** @class */ (function () {
    function AmdInputModule() {
    }
    AmdInputModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AmdInputDirective],
                    exports: [AmdInputDirective]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdInputModule.ctorParameters = function () { return []; };
    return AmdInputModule;
}());
export { AmdInputModule };
function AmdInputModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdInputModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdInputModule.ctorParameters;
}
//# sourceMappingURL=input.module.js.map
//# sourceMappingURL=input.module.js.map
